"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Element = /** @class */ (function () {
    function Element() {
    }
    return Element;
}());
exports.Element = Element;
//# sourceMappingURL=Element.js.map